import moment from 'moment';

export function formattedDate(date) {
  return moment(date).format('DD/MM/YYYY');
}

export function formattedDateBrToAmericanFormat(date) {
  return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
}

export function formatDate(date) {
  if (date) {
    if (date.length === 19) {
      const dateObj = new Date(date);
      const day = dateObj.getDate().toString().padStart(2, '0');
      const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      const year = dateObj.getFullYear().toString();

      return day + '/' + month + '/' + year;
    }
  }

  return date;
}

/**
 * Remove caracteres não alfanuméricos do item.
 *
 * @param {unknown} item - O item a ter caracteres removidos.
 * @return {string} - O item com caracteres não alfanuméricos removidos, ou o item original se não for uma string.
 */
export function removeCharacters(item) {
  return String(item).replace(/[^a-zA-Z0-9]/g, '');
}

export function convertInString(item) {
  if (item !== null && item !== undefined && item !== '') {
    return item.toString();
  }

  return item;
}

export function kbToMb(value) {
  if (!value) return '';

  const mbValue = value / (1024 * 1024);
  return mbValue.toFixed(2) + ' MB';
}

export function formattingString(str) {
  // Normaliza variantes de apóstrofo (curvo U+2018/2019, prime U+2032/2035, etc.) para o reto
  // antes de qualquer outro processamento, evitando divergências entre fontes (ex: ViaCEP vs back-end)
  str = str.replace(/[‘’‚‛′‵]/g, "'");

  str = str.normalize('NFD').replace(/[̀-ͯ]/g, '');
  str = str.replace(/[^\w\s']/gi, '');
  str = str.replace(/'/g, ' ').replace(/\s+/g, ' ').trim();
  str = str.toUpperCase();

  return str;
}

export function normalizeFilter(item, query) {
  const normalize = (text) => {
    return text
      ? text
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
      : '';
  };

  const normalizedItem = normalize(item);
  const normalizedQuery = normalize(query);
  return normalizedItem.includes(normalizedQuery);
}

export function normalizeFilterFields(fields, query) {
  return fields.some((field) => normalizeFilter(field, query));
}

export function normalizeSearch(data, search) {
  if (!search) return data;

  const normalize = (str) =>
    str
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();

  return data.filter((item) =>
    Object.values(item).some(
      (value) =>
        value !== null &&
        typeof value === 'string' &&
        normalize(value).includes(normalize(search)),
    ),
  );
}

export function formattedCpf(cpf) {
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function formattedCpfAndHideChacters(cpf) {
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.***.***-$4');
}

export function formattedCns(cnpj) {
  return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3.$4-$5');
}
